import { ForgeViewerOptions } from './forge-viewer.types';

export class ViewerCore {
    private static initializerPromise: Promise<void> | null = null;

    private viewer?: Autodesk.Viewing.GuiViewer3D | null;
    private options: ForgeViewerOptions;
    private container: HTMLElement;

    constructor(container: HTMLElement, options: ForgeViewerOptions) {
        this.container = container;
        this.options = options;
        this.viewer = null;
    }

    get instance(): Autodesk.Viewing.GuiViewer3D | null {
        return this.viewer ?? null;
    }

    private static ensureInitialized(accessToken: string): Promise<void> {
        if (!this.initializerPromise) {
            this.initializerPromise = new Promise((resolve) => {
                Autodesk.Viewing.Initializer(
                    {
                        accessToken,
                    },
                    () => {
                        resolve();
                    }
                );
            });
        }

        return this.initializerPromise;
    }

    async init(): Promise<void> {
        await ViewerCore.ensureInitialized(this.options.accessToken);

        this.viewer = new Autodesk.Viewing.GuiViewer3D(this.container);

        const code = this.viewer.start();

        if (code > 0) {
            this.viewer = null;
            throw new Error('Failed to start viewer: WebGL not supported or other error.');
        }
    }

    shutdown() {
        // Finish / tear down the viewer instance
        if (this.viewer) {
            try {
                // finish() is the usual public API
                this.viewer.finish();

                // In some setups people also call:
                // this.viewer.tearDown();
                // this.viewer.uninitialize();
            } catch (e) {
                console.warn('Error finishing viewer:', e);
            }

            this.viewer = null;
        }

        // Clear container DOM safely
        if (this.container) {
            try {
                // safer than removeChild(firstChild)
                this.container.innerHTML = '';
            } catch (e) {
                console.warn('Error clearing container:', e);
            }
        }

        // Global Forge shutdown
        try {
            Autodesk.Viewing.shutdown();
        } catch (e) {
            console.warn('Error in Autodesk.Viewing.shutdown():', e);
        }
    }
}
